import React from 'react';

import Button from '../../../components/Button';

import * as S from './styles';

import { Card } from '../styles';

export default function PreventiveHealthProgram() {
    return (
        <Card>
            <S.StyledTitle>Programa de saúde preventiva</S.StyledTitle>

            <Button type="secondary">
                <S.StyledLink href={process.env.REACT_APP_PREVENTIVE_HEALTH_PROGRAM_URL} target="_blank" rel="noreferrer">
                    Conheça nossos programas
                </S.StyledLink>
            </Button>
        </Card>
    );
}
